exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blockPurpose .purposeContent p,.blockPurpose .purposeContent ul,.blockPurpose .purposeContent li,.blockPurpose .purposeContent ol{margin:1rem 0 1rem 1rem}", ""]);

// exports
